import { Box, Button, Divider, Grid, InputAdornment, Typography } from "@mui/material";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { FaUserTie } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { Link } from "react-router-dom";
import { InputForm } from "../../ui/inputForm";
import { sendPasswordResetEmail } from "services/authServices/authServices";
import Swal from "sweetalert2";
import { useRef, useState } from "react";
import { Recaptcha } from "../login/components/recaptcha";
import ReCAPTCHA from "react-google-recaptcha";
import { setIsLoading, setMessageLoading } from "store";
import { useDispatch } from "react-redux";
import { Ayuda } from "../login/components/ayuda";

type Inputs = {
  user: string;
  email: string;
  email_confirm: string;
};

export const SendEmail = () => {
  const methods = useForm<Inputs>();
  const dispatch = useDispatch();
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [disabledButton, setDisabledButton] = useState(true);
  const [sendButton, setSendButton] = useState(false);
  const handleChangeRecaptcha = (value: any) => {
    if (value) {
      setDisabledButton(false);
    }
  };

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      setDisabledButton(true);
      dispatch(setIsLoading(true));
      setSendButton(true);
      dispatch(setMessageLoading("Enviando..."));
      await sendPasswordResetEmail({
        usuario: data.user,
        correo_personal: data.email,
        confirma_correo_personal: data.email,
      });
      setDisabledButton(false);
      setSendButton(false);
      dispatch(setIsLoading(false));
      dispatch(setMessageLoading(""));
      Swal.fire({
        icon: "success",
        title: "¡Éxito!",
        text: "Se ha enviado un correo electrónico con las instrucciones para restablecer su contraseña.",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        window.location.href = "/login";
      });
    } catch (error: any) {
      setDisabledButton(false);
      setSendButton(false);
      dispatch(setIsLoading(false));
      dispatch(setMessageLoading(""));
      if (error.response.status >= 400 && error.response.status < 500) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response.data.data,
          confirmButtonText: "Aceptar",
        });
      } else if (error.response.status >= 500) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Ha ocurrido un error interno, por favor inténtalo más tarde.",
          confirmButtonText: "Aceptar",
        });
      }
    }
  };

  return (
    <FormProvider {...methods}>
      <form className="w-full" onSubmit={methods.handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle1">
              Con este procedimiento, modificará tanto su contraseña del
              Tribunal Electrónico como del correo institucional. Ingrese su
              usuario y correo personal (que proporcionó al momento de tramitar
              su firma) para buscar su cuenta.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <InputForm
              type="text"
              name="user"
              label="Usuario"
              className="w-full my-6"
              error={methods.formState.errors?.user ? true : false}
              helperText={
                methods.formState?.errors?.user
                  ? methods.formState?.errors?.user.message
                  : ""
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <FaUserTie />
                  </InputAdornment>
                ),
              }}
              rules={{
                required: {
                  value: true,
                  message: "El campo usuario es requerido",
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <InputForm
              name="email"
              label="Correo personal"
              type="text"
              className="w-full"
              error={methods.formState.errors?.email ? true : false}
              helperText={
                methods.formState?.errors?.email
                  ? methods.formState?.errors?.email.message
                  : ""
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MdOutlineEmail />
                  </InputAdornment>
                ),
              }}
              rules={{
                required: {
                  value: true,
                  message: "El campo correo es requerido",
                },
                pattern: {
                  value: /^\w+([-.+_]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/,
                  message: "Ingrese un correo electrónico válido",
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <InputForm
              name="email_confirm"
              label="Confirmar Correo"
              type="text"
              className="w-full"
              error={methods.formState.errors?.email_confirm ? true : false}
              helperText={
                methods.formState?.errors?.email_confirm
                  ? methods.formState?.errors?.email_confirm.message
                  : ""
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MdOutlineEmail />
                  </InputAdornment>
                ),
              }}
              rules={{
                required: {
                  value: true,
                  message: "El campo confirmar correo es requerido",
                },
                pattern: {
                  value: /^\w+([-.+_]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/,
                  message: "Ingrese un correo electrónico válido",
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            { <Recaptcha
              recaptchaRef={recaptchaRef}
              handleChangeRecaptcha={handleChangeRecaptcha}
            /> }
          </Grid>
          <Grid item xs={12}>
            {<Button
              variant="contained"
              color="error"
              className="my-3 w-full"
              type="submit"
              disabled={disabledButton}
            >

              {sendButton ? "Enviando..." : "Buscar"}
            </Button>}
          </Grid>
        </Grid>
        <Grid container className="mt-8" justifyContent="center">
          <Grid item xs={12} textAlign="center">
            <Link to="/login" className="hover:underline text-red-700">¿Recordaste tu contraseña?</Link>
          </Grid>
          {/* <Grid item xs={12} sm={6} md={7} lg={7} xl={7} >
            <span className="text-sm	font-normal text-[#b91c1c]">
            Tel. (722) 167-92-00 Mesa de ayuda extensión 15401
            </span>
          </Grid> */}
        </Grid>
                <Box component="div" sx={{ mt:4, width: "100%" }}>
                  <Ayuda />
                </Box>
      </form>
    </FormProvider>
  );
};
